/**
 * 
 * key
 * 
 */


const key = 'aG9saWRheQ=='

export default key 